<section class="panel" [class.expanded]="!isCollapsed">
	<header class="text-18-bold text-uppercase text-md-16-bold text-sm-20 panel-header margin-standard">
		<a class="header-anchor" (click)="togglePanel($event)">
			<icon type="chevron-up" class="icon" [ngClass]="{ collapsed: isCollapsed }"></icon>
			<span class="icon-caption d-inline-block d-block-sm"> <ng-content select="header"></ng-content> </span>
		</a>
	</header>
	<section [@slideInOut] *ngIf="!isCollapsed" class="panel-content"><ng-content select="content"></ng-content></section>
</section>
